import type { UseMutationResult } from '@tanstack/react-query'
import { useMutation } from '@tanstack/react-query'

import { importTrade } from '@/features/wholesale/endpoints/trades'

export type UseImportTradeMutationResult = Omit<UseMutationResult<void, Error, File>, 'mutateAsync'> & {
  importTrade: UseMutationResult<void, Error, File>['mutateAsync']
}

export function useImportTradeMutation(): UseImportTradeMutationResult {
  const { mutateAsync, ...mutationResult } = useMutation({
    mutationFn: (file: File) => importTrade(file),
  })

  return {
    importTrade: mutateAsync,
    ...mutationResult,
  }
}
